<template>
  <div class="__card_tabs">
    <div 
      class="__card_tab"
      v-for="(element, index) in tabs"
      :key="index" 
    >
      <h1 
        class="__card_title"
        :class="(activeTab == index) ? 'active' : ''" 
        @click="chooseTab(index)"
      >
        <slot :name="`tab-${element.index}`">
          {{element.text}}
        </slot>
      </h1>

      <div 
        class="__card_wall"
        v-if="index < (tabs.length - 1)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    },

    active: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      activeTab: this.active,
    }
  },

  model: {
    prop: "active",
    event: "value"
  },

  methods: {
    chooseTab(index) {
      this.activeTab = index
      this.$emit('value', index)
      this.$emit('select', index)
    }
  },
};
</script>

<style scoped lang="scss">
.__card_tabs {
  display: flex;
  margin-bottom: 26px;
}

.__card_tab {
  display: flex;
}

.__card_wall {
  border-left: 2px solid #B9B9B9 ;
  margin: 0px 19px;
}

.active {
  color: #23313E !important;
}

.__card_title {
  margin: 0px;
  font-style: normal;
  font-weight: 600 !important;
  font-size: 20px;
  line-height: 30px;
  cursor: pointer;
  /* identical to box height, or 150% */

  letter-spacing: -0.01em;

  /* Dark */

  color: #a7acb1;
}
</style>